import { useMsal } from '@azure/msal-react'
import ProfileIcon from '@mui/icons-material/AccountCircle'
import EmailIcon from '@mui/icons-material/Email'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import FacebookIcon from '@mui/icons-material/Facebook'
import HomeIcon from '@mui/icons-material/Home'
import { useState } from 'react';
import LanguageIcon from '@mui/icons-material/Language'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { Box, Collapse, Link, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { useFetchPerson } from '@src/api/person-api'
import { LanguagePicker } from '@src/components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import IceberImage from '../../../media/if.png'
import { getLoanLabel } from '../../../services/loanUtils'; 

interface Props {
  isMobile: boolean
  open: boolean
  handleAccueilClick: () => void
  handleDrawerToggle: () => void; 
}
const DrawerContent = ({ isMobile, open, handleAccueilClick,handleDrawerToggle }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { instance } = useMsal()
  const [data] = useFetchPerson();
  const [selectedLoanId, setSelectedLoanId] = useState<number | null>(null);

  const mainBoxStyles = {
    color: 'white',
    backgroundColor: 'black',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
    '@media (max-width: 600px)': {
      paddingTop: '2rem',
    },
  }

  const listItemStyles = {
    '&:hover': {
      backgroundColor: '#373737',
    },
  }

  const listItemIconStyles = {
    color: '#aaaaaa',
    minWidth: '40px',
    '&:hover': {
      color: 'white',
    },
  }

  const listItemTextStyles = {
    '.MuiListItemText-primary': {
      fontSize: '13px',
      color: '#AEAEAE',
      '&:hover': {
        color: 'white',
      },
    },
  }

  const logoBoxStyles = {
    maxWidth: '65%',
    marginTop: '65px',
    marginBottom: '70px',
    marginLeft: '30px',
  }

  const socialIconsBoxStyles = {
    display: 'flex',
    justifyContent: 'center',
    padding: '10px 0',
    bottom: '0',
    width: '100%',
    cursor: 'pointer',
    '.MuiSvgIcon-root': {
      backgroundColor: '#ffffff',
      color: '#000000',
      margin: '0 4px', 
      borderRadius: '50%',
      padding: '5px',
      boxSizing: 'content-box',
      height: '15px',
      width: '17px',
      '@media (max-width: 600px)': {
        height: '14px', 
        width: '14px', 
        margin: '0 3px', 
      },
    },
    '@media (max-width: 600px)': {
      justifyContent: 'space-around', 
    },
  }

  return (
    <Box sx={mainBoxStyles}>
      {!isMobile && <Box component={'img'} src={IceberImage} alt="ICEBERG FINANCE" sx={logoBoxStyles} />}
      <Box sx={{ flex: 1 }}>
        <List sx={{ padding: 0 }}>
          <ListItemButton onClick={handleAccueilClick} sx={{ ...listItemStyles }}>
            <ListItemIcon sx={listItemIconStyles}>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={t('menus.home')} sx={{ ...listItemTextStyles }} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {data?.loans?.map((loan) => (
                <ListItemButton
                  key={loan.id}
                  onClick={() => {
                    navigate(`/home/${loan.id}`);
                    setSelectedLoanId(loan.id);
                    handleDrawerToggle();
                  }}
                  sx={{ ...listItemStyles,
                    pl: 4,
                      backgroundColor: loan.id === selectedLoanId ? '#282828' : 'inherit',
                      '&:hover': {
                        backgroundColor: '#373737', 
                      },
                      borderLeft: loan.id === selectedLoanId ? '5px solid #ffff' : 'none',
                   }}
                >
                  <ListItemText primary={`${getLoanLabel(loan.customerTypeId,t)} : ${loan.id}`} sx={{ ...listItemTextStyles }} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
          <ListItemButton onClick={() => { navigate('/profile'); handleDrawerToggle(); }} sx={{ ...listItemStyles }}>
            <ListItemIcon sx={listItemIconStyles}>
              <ProfileIcon />
            </ListItemIcon>
            <ListItemText primary={t('menus.myProfile')} sx={{ ...listItemTextStyles }} />
          </ListItemButton>
          <ListItemButton sx={{ ...listItemStyles }}>
            <ListItemIcon sx={listItemIconStyles}>
              <LanguageIcon />
            </ListItemIcon>
            <LanguagePicker sx={listItemTextStyles} />
          </ListItemButton>
          <ListItemButton
            component={Link}
            onClick={() => {
              void instance.logout()
              localStorage.clear()
              window.location.reload()
              handleDrawerToggle();
            }}
            sx={{ ...listItemStyles }}
          >
            <ListItemIcon sx={listItemIconStyles}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t('menus.logout')} sx={{ ...listItemTextStyles }} />
          </ListItemButton>
        </List>
      </Box>
      <Box sx={socialIconsBoxStyles}>
        <FacebookIcon onClick={() => { navigate(`/`); handleDrawerToggle(); }} />
        <LinkedInIcon  onClick={() => { navigate(`/`); handleDrawerToggle(); }} />
        <EmailIcon onClick={() => { navigate(`/contact-us`); handleDrawerToggle(); }} />
      </Box>
    </Box>
  )
}

export default DrawerContent
